export default "__VITE_ASSET__Bvissruv__"